<template lang="pug">
div
  Form(:data="company", :isSubmitting="isSubmitting", :isEdit="true", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useCompanyEdit from './useCompanyEdit'

export default {
  components: {
    Form,
  },

  setup() {
    const { show, update, company, isSubmitting } = useCompanyEdit()

    onMounted(show)

    return {
      company,
      update,
      isSubmitting,
    }
  },
}
</script>
